import React from 'react';
import { Camera } from 'lucide-react';
import { useBranding } from '../context/BrandingContext';

/**
 * Renders the FRAMEBOX brand: logo (uploaded image or camera icon fallback) + text lines.
 * Props:
 *  - size: 'sm' | 'md' | 'lg'  (default 'md')
 *  - variant: 'light' (dark bg) | 'dark' (light bg)
 *  - hideText: force hide text next to logo
 *  - align: 'left'|'right' (for tagline positioning)
 */
const BrandLogo = ({ size = 'md', variant = 'light', hideText = false, align = 'left' }) => {
  const { branding } = useBranding();
  const showText = !hideText && (branding?.show_text ?? true);
  const logoUrl = branding?.logo_url;

  const sizes = {
    sm: { img: 'h-6 w-auto max-w-[80px]', icon: 'w-5 h-5', title: 'text-sm', tag: 'text-[9px]' },
    md: { img: 'h-8 w-auto max-w-[110px]', icon: 'w-6 h-6', title: 'text-lg', tag: 'text-[10px]' },
    lg: { img: 'h-12 w-auto max-w-[160px]', icon: 'w-8 h-8', title: 'text-xl', tag: 'text-[11px]' },
  }[size] || {};

  const titleColor = variant === 'dark' ? 'text-slate-900' : 'text-white';
  const tagColor = variant === 'dark' ? 'text-slate-500' : 'text-[#C9A961]';

  return (
    <div className="flex items-center gap-2">
      {logoUrl ? (
        <img src={logoUrl} alt="FRAMEBOX" className={`${sizes.img} object-contain`} />
      ) : (
        <Camera className={`${sizes.icon} text-[#C9A961]`} strokeWidth={2.2} />
      )}
      {showText && (
        <div className={`leading-tight ${align === 'right' ? 'text-right' : ''}`}>
          <div className={`font-extrabold ${sizes.title} tracking-[0.2em] ${titleColor}`}>FRAMEBOX</div>
          <div className={`uppercase tracking-[0.3em] ${sizes.tag} ${tagColor} -mt-0.5`}>by Nicola Verardo</div>
        </div>
      )}
    </div>
  );
};

export default BrandLogo;
